module.exports = __webpack_public_path__ + "static/img/left-top-row-2.38807104.png";